import WYSIWYGContent from "../../../Components/WYSIWYGContent";
import H2 from "../../../Components/H2";

export const Qip3Columns = ({ title, copy, columns }) => {
  return (
    <div>
      {title && <H2>{title}</H2>}

      {copy && (
        <p
          className="text-center mb-10"
          dangerouslySetInnerHTML={{ __html: copy }}
        />
      )}

      {columns && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {columns.map((column, i) => (
            <div key={i} className="">
              <img
                src={column.featured_image}
                alt=""
                className="mb-5 aspect-square object-cover"
              />
              <div className="text-jay-blue text-base mb-6">
                {column.tag}
              </div>
              <h3 className="text-2xl">{column.headline}</h3>
              <WYSIWYGContent content={column.excerpt} />
              {column.cta && (
                <a href={column.cta.url} className="text-lg bg-error text-white min-h-14 px-6 py-2 min-w-48">
                  {column.cta.title}
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
